export const isAndroidDevice = () => /android/i.test(navigator.userAgent || navigator.vendor || window.opera)

export const isiOSDevice = () =>
  /iPad|iPhone|iPod/.test(navigator.userAgent || navigator.vendor || window.opera) &&
  !window.MSStream

export const isObject = value => typeof value === 'object' && !Array.isArray(value) && value !== null

export const isNullish = value => value === null || value === undefined

export const isNumber = value => typeof value === 'number' && !isNaN(value)

export const isPositiveNumber = (value, zeroIncluded = false) =>
  isNumber(value) && (zeroIncluded ? (value >= 0) : (value > 0))

export const formatTime = (
  value,
  fallbackValue,
  {showHours = false} = {}
) => {
  if (!isNumber(value) || value < 0) { return fallbackValue }

  const minutes = Math.floor((value % 3600) / 60)
  const seconds = value % 60

  return [
    ...(showHours ? [Math.floor(value / 3600)] : []),
    minutes,
    seconds
  ].map(v => v.toString().padStart(2, '0')).join(':')
}

export const generateRandomNumberInRange = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;



// WEBPACK FOOTER //
// ./src/helpers/common.js